module.exports = __webpack_public_path__ + "fonts/junction-light.2dfbd5c7.ttf";